/** The id of a list option matched by two terms: its value on the column and `pairTerm` on the list's `pairColKey`. */
export function pairedListOptionId(term: string, pairTerm: string): string {
  return JSON.stringify([term, pairTerm]);
}

/** `null` for any id {@link pairedListOptionId} did not build, e.g. a plain label. */
export function parsePairedListOptionId(id: string): { term: string; pairTerm: string } | null {
  if (!id.startsWith("[")) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(id);
  } catch {
    return null;
  }
  if (!Array.isArray(parsed) || parsed.length !== 2) return null;
  const [term, pairTerm] = parsed as unknown[];
  if (typeof term !== "string" || typeof pairTerm !== "string") return null;
  return { term, pairTerm };
}
